/**
 * Resolves which result view (list or map) should render first on a
 * booking-engine room search page, before the map-list request confirms
 * whether the merchant actually has a map. Any value other than the exact
 * literal 'MAP' (missing field, empty string, 'ROOM_LIST', or anything else)
 * defaults to the list view per the merchant config contract.
 * @param {Object} merchant merchant object from the getMerchant getter
 * @returns {string} 'map' or 'list'
 */
export function resolveDefaultViewMode(merchant) {
  const priority = merchant && merchant.booking_engine_priority_ui;
  return priority === 'MAP' ? 'map' : 'list';
}



// WEBPACK FOOTER //
// ./src/utils/beViewMode.js